// utils/mergeProperties.js
export function mergeProperties(properties = []) {
  if (!properties.length) return null;

  const sumNumbers = (vals, decimals = 2) =>
    Number(vals.reduce((sum, v) => sum + (parseFloat(v) || 0), 0).toFixed(decimals));

  const mergeYears = (vals) =>
    Array.from(new Set(vals.map((v) => parseInt(v, 10)).filter((v) => !isNaN(v))))
      .sort((a, b) => a - b)
      .join("\n");

  const joinVertical = (vals) =>
    vals.filter((v) => v !== null && v !== undefined && v !== "").join("\n");

  const base = structuredClone(properties[0]);

  const allMainAddresses = properties.flatMap((p) =>
  (p.rakennukset_fulls || [])
    .filter((r) => r.isMainBuilding)
    .map((r) => r.osoite)
);

    const uniqueMainAddresses = [...new Set(allMainAddresses.filter(Boolean))];


  // Merge kiinteistö-level fields
  base.kohteen_nimi = joinVertical(properties.map((p) => p.kohteen_nimi));
  base.kiinteistotunnus = joinVertical(properties.map((p) => p.kiinteistotunnus));
  base.mergedOsoite = joinVertical(uniqueMainAddresses);
  base.tontin_koko = sumNumbers(properties.map((p) => p.tontin_koko));
  base.rakennusten_lkm = sumNumbers(properties.map((p) => p.rakennusten_lkm));
  base.ulkorakennusten_lkm = sumNumbers(properties.map((p) => p.ulkorakennusten_lkm));
  base.huoneistojen_lkm = sumNumbers(properties.map((p) => p.huoneistojen_lkm));

  // Merge rakennusvuodet only from main buildings
  const mergedRakennusvuosi = mergeYears(
    properties.flatMap((p) =>
      (p.rakennukset_fulls || [])
        .filter((r) => r.isMainBuilding)
        .map((r) => r.rakennusvuosi)
    )
  );

  // Flatten all buildings (keep their original addresses)
  base.rakennukset_fulls = properties.flatMap((p, idx) =>
    (p.rakennukset_fulls || []).map((b) => ({
      ...b,
      rakennustunnus: b.rakennustunnus || `Kiinteistö ${idx + 1}`,
      sourceKiinteistoId: p.id_kiinteisto,
    }))
  );

  

  // Inject merged rakennusvuosi into the first main building only
  const firstMain = base.rakennukset_fulls.find((b) => b.isMainBuilding);
  if (firstMain) {
    firstMain.rakennusvuosi = mergedRakennusvuosi;
  }

    // Ensure metadata exists
    base.metadata = base.metadata || {};

    // Set the source for mergedOsoite using the first main building
    const firstMainBuilding = properties
    .flatMap((p) => p.rakennukset_fulls || [])
    .find((r) => r.isMainBuilding);

    base.metadata.mergedOsoite = {
    source: firstMainBuilding?.metadata?.osoite?.source || '',
    };

  return base;
}